import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select, Button } from "arv-reactcomponents";
import { Checkout } from "npmlinks-constants";

class DeliveryOptionDetails extends Component {
  static selectionText() {
    return {
      header: Checkout.CHECKOUT_DELIVERY_OPTIONS.DUMMY_TEXT,
      deliveryType: Checkout.CHECKOUT_DELIVERY_OPTIONS.DUMMY,
    };
  }

  constructor() {
    super();
    this.getList = this.getList.bind(this);
    this.updateDeliveryOption = this.updateDeliveryOption.bind(this);
  }
  get isStoresAvailable() {
    const { product, option } = this.props;
    return (
      product.storeCount > 0 &&
      option.deliveryType === Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK
    );
  }
  get isStoreSelected() {
    const { product, option } = this.props;
    return (
      product.store &&
      product.store.fcId &&
      option.deliveryType === Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK
    );
  }
  get otherDeliverableOptions() {
    const { product, option } = this.props;
    if (option === Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK) {
      return [];
    }
    return product.deliveryDetails;
  }
  updateDeliveryOption(option) {
    const selectionText = DeliveryOptionDetails.selectionText();
    if (option.deliveryType !== selectionText.deliveryType) {
      this.props.deliveryUpdate(option);
    }
  }
  getList(item) {
    if (item.deliveryType === Checkout.CHECKOUT_DELIVERY_OPTIONS.DUMMY) {
      return null;
    }
    const { deliveryShown } = this.props;
    const [selectedDelivery] = deliveryShown;
    const isSelected =
      selectedDelivery && selectedDelivery.deliveryType === item.deliveryType;
    return (
      <li className="nw-checkoutpage-delopts-selectli" key={item.value}>
        {isSelected && (
          <i className="icomoon-check nw-checkoutpage-delopts-check" />
        )}
        <span
          className={`${
            isSelected ? "is-selected" : ""
          } nw-checkoutpage-delopts-selecttext`}
        >
          {item.header}
        </span>
      </li>
    );
  }
  render() {
    const { product, openStoresModal } = this.props;
    const remainingStores = product.storeCount - 1;
    if (this.isStoreSelected) {
      return (
        <div className="nw-checkoutpagedeloptions-addrselected">
          <div className="nw-checkoutpagedeloptions-addresscontainer">
            <span className="nw-checkoutpagedeloptions-addrline strong">
              {product.store.fcName},{" "}
            </span>
            <span className="nw-checkoutpagedeloptions-addrline">
              {product.store.streetNo},{" "}
            </span>
            <span className="nw-checkoutpagedeloptions-addrline">
              {product.store.streetName},{" "}
            </span>
            <span className="nw-checkoutpagedeloptions-addrline">
              {product.store.state}
            </span>
          </div>
          {remainingStores > 0 && (
            <Button
              className="nw-checkoutpagedeloptions-morestorebutton"
              onClick={openStoresModal}
            >
              {remainingStores}{" "}
              {remainingStores > 1
                ? Checkout.CHECKOUT_MESSAGES.STORE.MORE_AVAILABLE_STORES.PLURAL
                : Checkout.CHECKOUT_MESSAGES.STORE.MORE_AVAILABLE_STORES.SINGLE}
            </Button>
          )}
        </div>
      );
    } else if (this.isStoresAvailable) {
      const count = product.storeCount;
      const replaceMessage = count > 1 ? "s" : "";
      return (
        <Button
          className="nw-checkoutpage-deloptions-availablestores"
          onClick={openStoresModal}
        >
          {count}{" "}
          {Checkout.CHECKOUT_MESSAGES.STORE.STORES_NEARBY.replace(
            "$count",
            replaceMessage,
          )}
        </Button>
      );
    } else if (this.otherDeliverableOptions.length > 1) {
      const selectedValue = DeliveryOptionDetails.selectionText();
      return (
        <div className="nw-checkoutpage-delopts-select-container">
          <Select
            className="nwc-select-secondary nwc-select-sm nw-checkoutpage-delopts-select"
            selectedValue={selectedValue}
            inpList={this.otherDeliverableOptions}
            getSelection={this.updateDeliveryOption}
            renderList={this.getList}
            compareProp="header"
          />
        </div>
      );
    }
    return null;
  }
}

DeliveryOptionDetails.propTypes = {
  product: PropTypes.shape({}).isRequired,
  option: PropTypes.shape({}).isRequired,
  deliveryShown: PropTypes.shape({}).isRequired,
  deliveryUpdate: PropTypes.func.isRequired,
  openStoresModal: PropTypes.func.isRequired,
};
const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: DeliveryOptionDetails,
  component: DeliveryOptionDetails,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/DeliveryOptions/DeliverOptionDetails/index.js